var CookieAcceptance = {

    constants: {
        $CookieAcceptance: $(".CookieAcceptance")
    },

    onDismissButtonClick: function () {
        var $CookieAcceptance = CookieAcceptance.constants.$CookieAcceptance;

        $CookieAcceptance.on('closed.bs.alert', function () {
            cookieHelper.setCookie("cookiesAccepted", "1", 365 * 100);
        });
    },

    init: function () {
        CookieAcceptance.onDismissButtonClick();
    }

}
$(function () {
    CookieAcceptance.init();
});
